import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ActionIcon from "../../Utility/ActionIcon";
import CustomButton from "../../Utility/Button";
import SearchBox from "../../Utility/SearchBox";

import { useDispatch, useSelector } from "react-redux";
import { SETSTATEOBJ, STATEDELETE as areaDELETE, STATEGET as areaGET } from "../../../redux/actions/State/States.actions";
import { DashboardBox, DashboardTable } from "../../Utility/DashboardBox";
import { AddModal } from "../../Utility/Modal";
import AddShipping from "./AddShipping";
import { SETSHIPPINGOBJ, SHIPPINGDELETE, SHIPPINGGET } from "../../../redux/actions/Shipping/Shipping.actions";

function Shipping() {
    // ==============================================================================================================
    const dispatch = useDispatch();
    const [ModalType, setModalType] = useState("");
    const [ModalName, setModalName] = useState("");
    const [ModalBox, setModalBox] = useState(false);
    const shippingArr = useSelector((state) => state.shipping.shippings);
    const shippingObj = useSelector((state) => state.shipping.shippingObj);
    const [ModalData, setModalData] = useState({});
    const [displayShippingArr, setDisplayShippingArr] = useState([]);
    const [query, setQuery] = useState("");
    const handleCategoryEdit = (row) => {
        console.log(row,"fdsfs")
        dispatch(SETSHIPPINGOBJ(row));
    };

    const [shippingMainArr, setShippingMainArr] = useState([]);

    const handleGet = () => {
        dispatch(SHIPPINGGET());
    };

    const handleCategoryDelete = (row) => {
        let confirm =window.confirm("Do you really want to delete this item?")
        if (confirm) {
            dispatch(SHIPPINGDELETE(row._id))
        }
    
    }

    useEffect(() => {
        handleGet()
    }, [])

    useEffect(() => {
        if (shippingArr?.length) {
            console.log(shippingMainArr,"shippingMainArrshippingMainArrshippingMainArr")
            setShippingMainArr(shippingArr)
            setDisplayShippingArr(shippingArr)
        }
    }, [shippingArr])

    const category_columns = [
        {
            name: "ID",
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Min",
            selector: (row) => row?.min,
        },
        {
            name: "Max",
            selector: (row) => row?.max,
        },
        {
            name: "Cost per Order",
            selector: (row) => row?.price,
        },
       
        {
            name: "Country",
            selector: (row) => row?.country,
        },
        // {
        //     name: "Status",
        //     minWidth: "210px",
        //     maxWidth: "211px",
        //     button: true,
        //     cell: (row) => <CustomButton greenBtn noIcon btnName={`${row.status == "APPROVED" ? "Active" : "InActive"}`} path={"/Location/View-Shipping"} />,
        // },
        {
            name: "Action",
            minWidth: "210px",
            maxWidth: "211px",
            cell: (row) => <ActionIcon Uniquekey={row._id} remove edit deletePath="/SetUp/Shipping" onDeleteClick={() => handleCategoryDelete(row)} isRedirected={true} onEditClick={() => handleCategoryEdit(row)} editPath="/SetUp/Shipping" />,
        },
    ];

    // ==============================================================================================================

    const handleFilterByQuery = (e, requiredParametersArr) => {
        let tempArr = displayShippingArr.filter(el => {
            for (const ele of requiredParametersArr) {
                console.log(`${el[ele]}`.toLowerCase().includes(`${e}`.toLowerCase()), "ele,el")
                if (`${el[`${ele}`.toLowerCase()]}`.toLowerCase().includes(`${e}`.toLowerCase())) {
                    // console.log("true")
                    return true;
                }
                else {
                    return false;
                }
            }
        })
        setQuery(e)
        setShippingMainArr([...tempArr])
        console.log([...tempArr], "...tempArr")
    }


    return (
        <main>
            <AddModal
                ModalBox={ModalBox}
                setModalBox={setModalBox}
                name={ModalName}
                ModalType={ModalType}
                data={ModalData}
            />
            <section className="product-category">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="blue-1 m-0">{shippingObj && shippingObj.name ? "Edit " : "Add "} Shipping</h5>
                                {/* <CustomButton isLink iconName="fa-solid fa-plus" btnName="BULK CATEGORY UPLOAD" path="/Product/Bulk-Category-Upload" roundedPill small /> */}
                            </div>
                            <DashboardBox>
                                <AddShipping />
                            </DashboardBox>
                        </div>
                        <div className="col-12 col-md-8">
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <h5 className="blue-1 m-0">Shipping List</h5>
                                <div className="d-flex gap-3 align-items-center">
                                    {/* <CustomButton isLink iconName="fa-solid fa-download" btnName="CATEGORY CSV" path="/Product/Bulk-Category-Upload" small roundedPill downloadAble /> */}
                                    <SearchBox setQuery={(e) => { handleFilterByQuery(e, ["name"]); }} query={query} extraClass="bg-white" />
                                </div>
                            </div>
                            <DashboardTable>
                                <DataTable columns={category_columns} data={shippingMainArr && shippingMainArr.length > 0 ? shippingMainArr : []} pagination />
                            </DashboardTable>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Shipping;
